import {alertActions} from "./alertActions";
import {reportServices} from "../../service/reportService";
import {affiliateNetworkConstants} from "../constants/affiliateNetworkConstants";
import {affNetworkServices} from "../../service/affiliateNetworkService";
import ExportCSV from "../../components/export/ExportCSV";

export const affiliateNetworkActions = {
    getReport,
    archive,
    restore,
    loadMoreRows,
    updateName,
    updateTags,
    updateOrderBy,
    updateSortBy,
    updateSortColumns,
    rerender,
    changeWorkspace
};

function loadMoreRows(groupBy, from, to, timezone, name, tags, isDeleted, page, pageSize, orderBy, sortBy, currencyCode, metricFilters, columns, workspace) {
    return dispatch => {
        dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_LOADING_SPINNER});
        dispatch(alertActions.error(""));
        reportServices.getReport(
            {
                groupBy, from, to, timezone, name, tags, isDeleted, page, pageSize, orderBy, sortBy, currencyCode,
                metricFilters, columns, workspace
            }
        )
            .then((result) => {
                dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_INFINITY_SCROLL, result});
            }).catch((error) => {
                dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function getReport(groupBy, from, to, timezone, name, tags, isDeleted, page, pageSize, orderBy, sortBy, currencyCode, exportData, metricFilters, columns, workspace) {
    return dispatch => {
        dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_LOADING_SPINNER});
        dispatch(alertActions.error(""));
        reportServices.getReport(
            {
                groupBy,
                from,
                to,
                timezone,
                name,
                tags,
                isDeleted,
                page,
                pageSize,
                orderBy,
                sortBy,
                currencyCode,
                exportData,
                metricFilters,
                columns,
                workspace
            }
        )
            .then((result) => {
                if (exportData === "csv") {
                    ExportCSV({fileName: "affiliate_networks_" + from + "_to_" + to, data: result});
                    dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_STOP_LOADING_SPINNER});
                } else {
                    dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_GET_DATA, result});
                }
            }).catch((error) => {
                dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function archive(ids) {
    return dispatch => {
        dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_LOADING_SPINNER});
        affNetworkServices.archive(ids)
            .then(() => {
                dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_ARCHIVE});
            }).catch((error) => {
                dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_ERROR, error});
            }
        );
    };
}

function restore(ids) {
    return dispatch => {
        dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_LOADING_SPINNER});
        affNetworkServices.restore(ids)
            .then(() => {
                dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_RESTORE});
            }).catch((error) => {
                dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_ERROR, error});
            }
        );
    };
}

function updateOrderBy(orderBy) {
    return (dispatch) => {
        dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_UPDATE_ORDER_BY, orderBy});
    };
}

function updateSortBy(sortBy) {
    return (dispatch) => {
        dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_UPDATE_SORT_BY, sortBy});
    };
}

function updateName(name) {
    return (dispatch) => {
        dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_UPDATE_NAME, name});
    };
}

function updateTags(tags) {
    return (dispatch) => {
        dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_UPDATE_TAGS, tags});
    };
}

function updateSortColumns(sortColumns) {
    return (dispatch) => {
        dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_UPDATE_SORT_COLUMNS, sortColumns});
    };
}

function rerender() {
    return dispatch => {
        dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_RERENDER});
    };
}

function changeWorkspace(data) {
    return dispatch => {
        dispatch({type: affiliateNetworkConstants.AFFILIATE_NETWORKS_LOADING_SPINNER});
        affNetworkServices.bulkAffiliateNetworkUpdate(data)
            .then(() => {
                dispatch({type: affiliateNetworkConstants.BULK_UPDATE_CHANGE_WORKSPACE});
                dispatch(alertActions.success("Workspace is successfully updated."));
            }).catch((error) => {
                dispatch(alertActions.error("Changing workspace failed: " + error?.response?.data?.error));
            }
        );
    };
}